"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.randomIntDependencies = void 0;

var _dependenciesTypedGenerated = require("./dependenciesTyped.generated.js");

var _factoriesAny = require("../../factoriesAny.js");

/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
var randomIntDependencies = {
  typedDependencies: _dependenciesTypedGenerated.typedDependencies,
  createRandomInt: _factoriesAny.createRandomInt
};
exports.randomIntDependencies = randomIntDependencies;